import React from "react";
import { HistoryIcon, UsersIcon, BoxIcon, PencilLineIcon } from "lucide-react";
export type ClinicianTab = 'queue' | 'completed' | 'amend';
type ClinicianServiceCardsProps = {
  activeTab: ClinicianTab;
  onSelect: (tab: ClinicianTab) => void;
};
const cards: Array<{
  tab: ClinicianTab;
  name: string;
  caption: string;
  icon: BoxIcon;
  bg: string;
  ring: string;
}> = [{
  tab: 'queue',
  name: 'Active Queue',
  caption: 'Patients awaiting consultation',
  icon: UsersIcon,
  bg: 'bg-[#2563EB]',
  ring: 'ring-[#2563EB]'
}, {
  tab: 'completed',
  name: 'Completed Consultations / History',
  caption: 'Past consultations',
  icon: HistoryIcon,
  bg: 'bg-[#E0106F]',
  ring: 'ring-[#E0106F]'
}];
export function ClinicianServiceCards({
  activeTab,
  onSelect
}: ClinicianServiceCardsProps) {
  return <div className="flex flex-wrap gap-3" data-id="element-6634" data-mp="1hvtgfnc41smx">
      {cards.map(({
      tab,
      name,
      caption,
      icon: Icon,
      bg,
      ring
    }) => {
      const isActive = activeTab === tab;
      return <button key={tab} type="button" onClick={() => onSelect(tab)} aria-pressed={isActive} className={`${bg} inline-flex max-w-full items-center gap-3 rounded-xl py-3 pl-3 pr-5 text-left text-white shadow-md shadow-gray-300/40 transition-transform duration-150 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-offset-2 ${ring} ${isActive ? 'ring-4 ring-offset-2 ring-offset-chrome-canvas' : ''}`} data-id="element-6635" data-mp="3je2rmmepubu8">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/20" data-id="element-6636" data-mp="30icrl4qcfpiz">
              <Icon className="h-[18px] w-[18px] text-white" strokeWidth={2} aria-hidden="true" data-id="element-6637" data-mp="2vjjng2wy5avh" />
            </span>
            <span data-id="element-6638" data-mp="35fmm2yslardo">
              <span className="block whitespace-nowrap text-sm font-semibold leading-tight" data-id="element-6639" data-mp="35f3f2d4h9nef">
                {name}
              </span>
              <span className="block whitespace-nowrap text-xs text-white/85" data-id="element-6640" data-mp="pmdw5i6wtnz4">
                {caption}
              </span>
            </span>
          </button>;
    })}
      <button type="button" onClick={() => onSelect('amend')} aria-pressed={activeTab === 'amend'} className={`inline-flex max-w-full items-center gap-3 rounded-xl border-2 border-[#2563EB] bg-white py-3 pl-3 pr-5 text-left text-[#1E3A8A] shadow-md shadow-gray-300/40 transition-transform duration-150 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#2563EB] focus-visible:ring-offset-2 ${activeTab === 'amend' ? 'ring-4 ring-[#2563EB] ring-offset-2 ring-offset-chrome-canvas' : ''}`} data-id="element-6641" data-mp="rt3upoxwkc07">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#2563EB]/10" data-id="element-6642" data-mp="e172zm05c44c">
          <PencilLineIcon className="h-[18px] w-[18px] text-[#2563EB]" strokeWidth={2} aria-hidden="true" data-id="element-6643" data-mp="iypffmddh1h3" />
        </span>
        <span data-id="element-6644" data-mp="nsjsi6yh2i77">
          <span className="block whitespace-nowrap text-sm font-semibold leading-tight" data-id="element-6645" data-mp="3mgz3nxe67zn7">
            Amend File
          </span>
          <span className="block whitespace-nowrap text-xs text-gray-500" data-id="element-6646" data-mp="3rescyzart9rp">
            Correct or add notes to a file
          </span>
        </span>
      </button>
    </div>;
}